import React from 'react';

const CTASection = () => {
  return (
    <section className="py-5 text-center text-white" style={{ background: "linear-gradient(135deg, #0d6efd, #0043a8)" }}>
      <div className="container py-4">
        <h2 className="display-5 fw-bold mb-3 text-warning">Repair Your Office Chair Instead of Replacing It!!</h2>
<p className="lead mb-4 text-white">
  🔧 Broken Office Chair? Get Same-Day Repair at Your Doorstep!
</p>
        
        <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
          {/* Direct Call Button */}
          <a 
            href="tel:+919765960907" 
            className="btn btn-light btn-lg rounded-pill shadow-lg px-4 fw-bold"
            style={{ color: "#0d6efd" }}
          >
            <i className="fas fa-phone-alt me-2"></i> +91 97659 60907
          </a>
          
          {/* WhatsApp Message Button */}
          <a 
            href="https://wa.me/919765960907?text=Hello,%20I%20need%20chair%20repair%20service." 
            target="_blank" 
            rel="noreferrer" 
            className="btn btn-success btn-lg rounded-pill shadow-lg px-4 fw-bold"
          >
            <i className="fab fa-whatsapp me-2 fa-lg"></i> WhatsApp करें
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;